// src/components/PrivateRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { refreshAccessToken, loadUser } from '../redux/auth/authSlice';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { user, loading } = useSelector((state) => state.auth);

  // We'll track our own local "verifying" state so we don't just flash
  // a redirect if we haven't tried refreshing yet.
  const [verifying, setVerifying] = useState(true);

  useEffect(() => {
    // If the user isn't in Redux, let's try refreshing and loading
    async function verifyAuth() {
      try {
        if (!user) {
          // Attempt to get a fresh access token
          const newToken = await dispatch(refreshAccessToken()).unwrap();
          // If refresh worked, load the user
          if (newToken) {
            await dispatch(loadUser({ accessToken: newToken })).unwrap();
          }
        }
      } catch (error) {
        // If refresh or loadUser fails, user stays null
      } finally {
        setVerifying(false);
      }
    }

    verifyAuth();
  }, [dispatch, user]);

  // If Redux is currently in a loading state or we haven't finished verifying,
  // show a simple spinner or placeholder
  if (loading || verifying) {
    return <div>Loading...</div>;
  }

  // After we've attempted verification:
  // If there's still no user => not authenticated => go to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // Otherwise => user is loaded, so render the child route component
  return children;
};

export default PrivateRoute;